/**
 * Совместимая с WebKit замена `AbortSignal.any`.
 * Возвращаемый signal отменяется по первому из источников.
 */
export function combineAbortSignals(...signals: readonly AbortSignal[]): AbortSignal {
  const controller = new AbortController()
  const cleanup = (): void => {
    for (const signal of signals) signal.removeEventListener('abort', abort)
  }
  const abort = (): void => {
    if (!controller.signal.aborted) controller.abort()
    cleanup()
  }
  controller.signal.addEventListener('abort', cleanup, { once: true })
  for (const signal of signals) {
    if (signal.aborted) {
      controller.abort()
      break
    }
    signal.addEventListener('abort', abort, { once: true })
  }
  return controller.signal
}
